const ACTION_PATH = 'app/anexos'

export const CALL_EXCLUIR_ANEXO = `${ACTION_PATH}/CALL_EXCLUIR_ANEXO`

export const callExcluirAnexo = (id) => ({
  type: CALL_EXCLUIR_ANEXO,
  payload: id,
})
